import PropTypes from "prop-types";
import React from "react";
import { motion } from "framer-motion";
import { Flex, Box, Text, useMantineTheme } from "@mantine/core";
import { useStylesLoader } from "../utils/mantine/useStylesLoader";

const Loading = ({ title = "", text = "" }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes } = useStylesLoader();
  return (
    <Box className={classes.loader}>
      <Box className="block">
        <Flex
          justify={theme.flex.justify.center}
          style={() => ({
            height: "6rem",
          })}
        >
          <motion.span
            className="animation"
            animate={{
              rotate: 360,
            }}
            transition={{
              repeat: Infinity,
              duration: 1,
              ease: "linear",
            }}
          />
        </Flex>
        <Box>
          <Text className="text-1">{title}</Text>
          <Text className="text-2">{text}</Text>
        </Box>
      </Box>
    </Box>
  );
};

Loading.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Loading;
